import React, { Component } from 'react';
import { Grid, Card, Image, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Dialogmessage from '../../dialog';
import Loading from '../../loading';
import Server from '../../../functions/server'
import $ from "jquery";

class Edit extends Component {

  state = {
    data: null,
    load: false,
    message: '',
    error: '',
    dialogstatus: false,
    branch: '',
    min_stock: '',
    rackno: ''
  }

  componentDidMount() {
    this.setValuesToState(this.props);
  }

  componentWillReceiveProps(props) {
      this.setValuesToState(props);
  }

  setValuesToState(props) {
    let data = props.data;
    this.setState({
      branch: data.branch,
      min_stock: data.min_stock,
      rackno: data.rackno
    })
  }

  updatebranch() {
    let context = this;
    let partno = this.props.partno;
    let branch = document.getElementById('branch').value;
    let stock = document.getElementById('stock').value;
    let rack = document.getElementById('rack').value;
    if (branch == '' || branch == null || branch == undefined) {
      context.setState({ error: 'Enter branch fields!!!' })
      return;
    }
    if (stock == '' || stock == null || stock == undefined) {
      context.setState({ error: 'Enter stock fields!!!' })
      return;
    }
    if (rack == '' || rack == null || rack == undefined) {
      context.setState({ error: 'Enter rack no fields!!!' })
      return;
    }
    context.setState({
      load: true,
      message: 'Spare Branch Editing!!!'
    });
    let data1 = {'partno': partno, 'branch': branch, 'min_stock': stock, 'rackno': rack};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/updatebranch.php',
      success: function(data)
      {
        console.log(data);
        if (data == 1) {
          context.setState({
            load: false,
            dialogmessage: 'Branch Edited successfully!!!',
            dialogstatus: true,
          });
        }
        else {
          context.setState({
            load: false,
          });
          alert('Try again');
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  onChange = (type) => (e, {value}) => {
    this.setState({
      [type]: value
    })
  }

  closedialog() {
    this.setState({
      dialogstatus: false
    })
  }

  render() {
    let { load, message, dialogmessage, dialogstatus } = this.state;
    let loading, dialogs;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (dialogstatus) {
      dialogs = (<Dialogmessage message={dialogmessage} closedialog={this.closedialog.bind(this)} dialogstatus={dialogstatus} />)
    }
    console.log(this.props.data);
    let x = (
        <div>
          <Card fluid>
            <Grid style={{padding: '1%'}}>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                Brach<br/>
                <Input id='branch' value={this.state.branch}
                onChange={this.onChange('branch')}
                focus defaultValue='vinoth' placeholder='Branch'
                style={{ borderColor: '#5A9CBB' }} fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Min Stock<br/>
                <Input id='stock' value={this.state.min_stock}
                onChange={this.onChange('min_stock')}
                type="number" focus placeholder='Min Stock'
                style={{ borderColor: '#5A9CBB' }} fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}>
                Rack No<br/>
                <Input id='rack' focus value={this.state.rackno}
                onChange={this.onChange('rackno')}
                placeholder='Rack No' style={{ borderColor: '#5A9CBB' }}
                fluid />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <center><div style={{color: 'red', fontSize: 13, fontWeight: 'bold'}}>{this.state.error}</div></center>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <Button fluid positive onClick={this.updatebranch.bind(this)}>Save</Button>
              </Grid.Column>
            </Grid>
          </Card>
        </div>
      );
    return (
      <div style={{padding: '1%'}}>
        {x}
        {loading}
        {dialogs}
      </div>
    );
  }
}

export default Edit;
